import {
  checkValidate,
  deleteAnswer,
  deleteQuestion,
  getListQuestionAndAnswers,
  postAnswer,
  postQuestion,
  checkValidateAnswer,
} from '@/apis/question-answer';
import { QUESTION_AND_ANSWER } from '../mutation-types';

export const state = {
  dataQuestionAnswers: [],
  checkValidate: '',
  checkValidateAnswer: '',
  createData: '',
  createDataAnswer: '',
};

export const getters = {
  dataQuestionAnswers: (state) => state.dataQuestionAnswers,
};

export const mutations = {
  [QUESTION_AND_ANSWER.POST_QUESTION](state, data) {
    state.createData = data;
  },
  [QUESTION_AND_ANSWER.POST_ANSWER](state, data) {
    state.createDataAnswer = data;
  },
  [QUESTION_AND_ANSWER.CLEAR_DATA_QUESTION](state, data) {
    state.dataQuestionAnswers = state.dataQuestionAnswers.filter(el => el.question_id !== data.question_id);
  },
  [QUESTION_AND_ANSWER.GET_LIST_QUESTION_AND_ANSWER](state, data) {
    if (!data.error) {
      state.dataQuestionAnswers = data;
    }
  },
  [QUESTION_AND_ANSWER.QUESTION_ANSWER_VALIDATE](state, data) {
    state.checkValidate = data;
  },
  [QUESTION_AND_ANSWER.ANSWER_ANSWER_VALIDATE](state, data) {
    state.checkValidateAnswer = data;
  },
};

export const actions = {
  async getListQuestionAndAnswer({ commit }, id) {
    const res = await getListQuestionAndAnswers(id);
    commit(QUESTION_AND_ANSWER.GET_LIST_QUESTION_AND_ANSWER, res);

    return res;
  },
  async postQuestion({ commit }, payload) {
    const res = await postQuestion(payload);
    commit(QUESTION_AND_ANSWER.POST_QUESTION, res);

    return res;
  },
  async postAnswer({ commit }, payload) {
    const res = await postAnswer(payload);
    commit(QUESTION_AND_ANSWER.POST_ANSWER, res);

    return res;
  },
  async deleteQuestion({ commit }, id) {
    await deleteQuestion(id);
  },
  async checkValidate({ commit }, payload) {
    const res = await checkValidate(payload);
    if (res.error) {
      return res;
    }
    commit(QUESTION_AND_ANSWER.QUESTION_ANSWER_VALIDATE, res);
    return false;
  },
  async clearDataQuestion({ commit }, data) {
    commit(QUESTION_AND_ANSWER.CLEAR_DATA_QUESTION, data);
  },
  async deleteAnswer({ commit }, id) {
    await deleteAnswer(id);
  },
  async checkValidateAnswer({ commit }, payload) {
    const res = await checkValidateAnswer(payload);
    if (res.error) {
      return res;
    }
    commit(QUESTION_AND_ANSWER.ANSWER_ANSWER_VALIDATE, res);
    return false;
  },
};
